import { render, staticRenderFns } from "./FullSupplyChain.vue?vue&type=template&id=036d8c90&scoped=true"
import script from "./FullSupplyChain.vue?vue&type=script&lang=js"
export * from "./FullSupplyChain.vue?vue&type=script&lang=js"
import style0 from "./FullSupplyChain.vue?vue&type=style&index=0&id=036d8c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d8c90",
  null
  
)

export default component.exports